import { render, staticRenderFns } from "./CreateAccount_done.vue?vue&type=template&id=10cfdd97&scoped=true&"
import script from "./CreateAccount_done.vue?vue&type=script&lang=js&"
export * from "./CreateAccount_done.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccount_done.vue?vue&type=style&index=0&id=10cfdd97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cfdd97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
